export interface ICategory {
  id: string;
  categoryLocaleMetadata: ICategoryLocaleMetadata[];
  children: any;
}

export interface ICategorySearchResult {
  id: string;
  name: string;
}

export interface ICategoryLocaleMetadata {
  id: string;
  name: string;
  locale: string;
}

export interface ICategoryAdd {
  parentId: string;
  categoryLocaleMetadata: ICategoryLocaleMetadata;
}

export interface ICategoryLocaleMetadataAdd {
  name: string;
  locale: string;
}
